import { render, staticRenderFns } from "./TitleDetailTitleSidebarV1.vue?vue&type=template&id=7c247a48"
import script from "./TitleDetailTitleSidebarV1.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleDetailTitleSidebarV1.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleDetailTitleSidebarV1.vue?vue&type=style&index=0&id=7c247a48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports